var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaothers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.997 2.568c-1-1.169-2.667-1.483-3.92-.413C.825 3.225.648 5.015 1.632 6.28c.818 1.053 3.293 3.272 4.104 3.99.09.08.136.121.19.137a.254.254 0 0 0 .142 0c.053-.016.098-.056.19-.137.81-.718 3.285-2.937 4.103-3.99.984-1.266.829-3.066-.445-4.125-1.274-1.059-2.92-.756-3.92.413Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaothers);
export default __webpack_public_path__ + "static/media/vaothers.ace52ac1e30274f43a1ed6c6be6145a0.svg";
export { ForwardRef as ReactComponent };